"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("../../../common/Modal/Modal"));
var _APLabelWithText = _interopRequireDefault(require("../../../common/APLabelWithText"));
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
var _dateHelper = require("../../../../helpers/dateHelper");
var _orderEntryFormConstants = require("../../../../constants/sendOrder/orderEntryFormConstants");
var _orderHelper = require("../../../../helpers/orderHelper.js");
require("./BuySellConfirmationModalComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('buy-sell-order-confirmation');
var BuySellConfirmationModalComponent = /*#__PURE__*/function (_React$Component) {
  function BuySellConfirmationModalComponent(props) {
    var _this;
    _classCallCheck(this, BuySellConfirmationModalComponent);
    _this = _callSuper(this, BuySellConfirmationModalComponent, [props]);
    _defineProperty(_this, "placeOrder", function () {
      var _this$props = _this.props,
        confirmReport = _this$props.confirmReport,
        buySellForm = _this$props.buySellForm;
      _this.setState({
        submitting: true
      });
      confirmReport(buySellForm.values).then(function () {
        _this.setState({
          submitting: false
        });
      }, console.error);
    });
    _this.state = {
      submitting: false
    };
    return _this;
  }
  _inherits(BuySellConfirmationModalComponent, _React$Component);
  return _createClass(BuySellConfirmationModalComponent, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var responseMessage = this.props.buySellForm.values.responseMessage;
      var nextResponseMessage = nextProps.buySellForm.values.responseMessage;
      if (responseMessage && nextResponseMessage) {
        return false;
      }
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props2 = this.props,
        buySellForm = _this$props2.buySellForm,
        isOpen = _this$props2.isOpen,
        _close = _this$props2.close,
        selectedInstrument = _this$props2.selectedInstrument,
        products = _this$props2.products,
        price = _this$props2.price,
        quantity = _this$props2.quantity,
        finalQuantity = _this$props2.finalQuantity,
        onClose = _this$props2.onClose,
        hideFees = _this$props2.hideFees,
        displayPricePerUnit = _this$props2.displayPricePerUnit,
        pricePerUnit = _this$props2.pricePerUnit;
      var isBuySide = buySellForm.values.side === _orderEntryFormConstants.buyValue;
      var product = selectedInstrument.Product1Symbol;
      var responseMessage = buySellForm.values.responseMessage;
      var buttonText = responseMessage ? t('OK') : isBuySide ? t('Confirm Buy Order') : t('Confirm Sell Order');
      return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
        isOpen: isOpen,
        title: isBuySide ? t('Buy {{product}}', {
          product: selectedInstrument.Product1Symbol
        }) : t('Sell {{product}}', {
          product: selectedInstrument.Product1Symbol
        }),
        close: function close() {
          _close();
          onClose();
        },
        footer: {
          buttonText: buttonText,
          disabled: this.state.submitting,
          onClick: responseMessage ? function () {
            _close();
            onClose();
          } : this.placeOrder,
          overrideClose: true
        },
        customClass: bemClasses('modal')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses()
      }, /*#__PURE__*/_react["default"].createElement("h3", {
        className: bemClasses('header')
      }, responseMessage || t('Confirmation')), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
        customClass: bemClasses(),
        label: t('Order Type'),
        text: t('Market Order')
      }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
        customClass: bemClasses(),
        label: isBuySide ? t('{{product}} to Buy', {
          product: product
        }) : t('{{product}} to Sell', {
          product: product
        }),
        text: quantity
      }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
        customClass: bemClasses(),
        label: t("Total Transaction Cost"),
        text: "".concat(selectedInstrument.Product2Symbol, " ").concat(price)
      }), displayPricePerUnit && /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
        customClass: bemClasses(),
        label: t("Price Per Unit"),
        text: pricePerUnit
      }), !hideFees && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
        customClass: bemClasses(),
        label: t("Fee"),
        text: (0, _orderHelper.getOrderFee)(buySellForm.values, products)
      }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
        customClass: bemClasses(),
        label: t("Final Quantity"),
        text: "".concat(isBuySide ? selectedInstrument.Product1Symbol : selectedInstrument.Product2Symbol, " ").concat(finalQuantity)
      })), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
        customClass: bemClasses(),
        label: t('Date'),
        text: (0, _dateHelper.formatDateTime)(new Date())
      })));
    }
  }]);
}(_react["default"].Component);
BuySellConfirmationModalComponent.defaultProps = {
  displayPricePerUnit: false
};
BuySellConfirmationModalComponent.propTypes = {
  isBuySide: _propTypes["default"].bool.isRequired,
  buySellForm: _propTypes["default"].object.isRequired,
  close: _propTypes["default"].func.isRequired,
  isOpen: _propTypes["default"].bool.isRequired,
  confirmReport: _propTypes["default"].func.isRequired,
  selectedInstrument: _propTypes["default"].object.isRequired,
  products: _propTypes["default"].object.isRequired,
  price: _propTypes["default"].oneOfType([_propTypes["default"].number.isRequired, _propTypes["default"].string.isRequired, _propTypes["default"].object.isRequired]),
  quantity: _propTypes["default"].oneOfType([_propTypes["default"].number.isRequired, _propTypes["default"].string.isRequired]),
  finalQuantity: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].object]),
  onClose: _propTypes["default"].func.isRequired,
  displayPricePerUnit: _propTypes["default"].bool.isRequired,
  pricePerUnit: _propTypes["default"].string
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)('order')(BuySellConfirmationModalComponent);